export class BillerUpdate
{
    updateid: string;
    updatebillername: string;
    updaterate: string;   
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/updatebillermodel.ts